// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-tree-node[data-v-5135cb1c] {\n  font-size: 16px;\n}\n.custom-tree-node-btn[data-v-5135cb1c] {\n  margin-left: 10px;\n}\n.selected-node[data-v-5135cb1c] {\n  color: #1684FC;\n}\n.biaoti[data-v-5135cb1c] {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n[data-v-5135cb1c] .el-dialog__body {\n  padding: 0 20px;\n}\n", ""]);
// Exports
module.exports = exports;
